import { UiRouterTitleService } from './ui.router-title.service';
import { TransitionService } from '@uirouter/angularjs';

export function uiRouterTitleRun( $transitions: TransitionService,
                                  uiRouterTitleService: UiRouterTitleService ) {
  $transitions.onSuccess({}, ( transition ) => {
    const titleToken = uiRouterTitleService.getToken();
    const tokens = transition.getResolveTokens();
    if ( tokens.indexOf(titleToken) >= 0 ) {
      const $title = transition.injector().get(titleToken);
      uiRouterTitleService.setTitle(`${$title} - ${uiRouterTitleService.suffix}`);
    } else {
      uiRouterTitleService.setTitle(uiRouterTitleService.defaultTitle);
    }
  });
}

uiRouterTitleRun.$inject = [
  '$transitions',
  'UiRouterTitleService'
];



// WEBPACK FOOTER //
// ./app/shared/directives/ui-router-title/ui-router-title.run.ts